import load from '#core/load';
import util from '#core/util';
import jump from '#common/jump';


const state = window.teal_state = window.teal_state || {};
state.hash = state.hash || {};
state.hash.link_attributes = state.hash.link_attributes || {};

const href_attr = 'href';
const any_link_$ = 'a';


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('hash')) return false;
		
		load.content(() => {
		});
		load.all(() => {
			convert_links();
		});
	},
	
	
	/**
	 * Set link target selector and associated attribute name
	 * 
	 * A link containing a hash that links to an element on the current page that
	 * matches the specified selector will have its hash moved to the attribute.
	 * This allows us to process all kinds of links with hashes that go to
	 * different things: jump links, tabs, modals, etc. Each link is checked to
	 * see if it points to something that's on the current page, and converted to
	 * allow the functionality that is particular to the target pattern.
	 * 
	 * Example:
	 * - Link before: <a href="current-page.html#section-1">Section 1</a>
	 * - Target: <div id="section-1" class="nice">This is section 1</div>
	 * - Selector: .nice
	 * - Attribute: data-jump-target
	 * - Link after: <a href="#" data-jump-target="section-1">Section 1</a>
	 * 
	 * @param {string} selector
	 * @param {string} attribute
	 */
	setLinkAttribute(selector, attribute) {
		state.hash.link_attributes[selector] = attribute;
	},
	
};

export default module;
module.init();


/**
 * Convert links with hashes for same-page destination
 * 
 * Jump links and other same-page links don't work if they reference the page
 * that you're currently viewing, as the browser doesn't know not to reload
 * the page. This looks for links to the current page, and moves the hash to
 * a separate attribute.
 */
function convert_links() {
	const current_url = util.currentURL();
	
	document.querySelectorAll(any_link_$).forEach($link => {
		const href = $link.getAttribute(href_attr);
		if (!href) return false;
		
		const hash_index = href.indexOf('#');
		if (hash_index === -1) return false;
		
		// Only convert links that have a hash
		let href_hash = href.substring(hash_index + 1);
		if (!href_hash) return false;
		
		// Only convert links that point to the current page
		const href_without_hash = href.substring(0, hash_index);
		if (
			href_without_hash.length
			&& href_without_hash !== current_url
			&& href_without_hash !== window.location.pathname
		) return false;
		
		// Find target element by hash, or by ID if hash is not a valid selector
		let $target = null;
		const id_$ = `#${href_hash}`;
		if (util.isValidSelector(href_hash)) {
			$target = document.querySelector(href_hash);
		}
		if (
			!$target
			&& util.isValidSelector(id_$)
		) {
			$target = document.querySelector(id_$);
			if ($target) {
				href_hash = id_$;
			}
		}
		if (!$target) return false;
		
		// Check if $target matches any of the keys in link_attributes
		let attribute_name = null;
		for (let [selector, attribute] of Object.entries(state.hash.link_attributes)) {
			if (!$target.matches(selector)) continue;
			
			attribute_name = attribute;
			break;
		}
		
		// If attribute name is explicitly false, don't convert the link
		if (attribute_name === false) return false;
		
		// Use jump target attribute as a last resort, because jump targets can be
		// anything, and don't have any particular selectors to identify them
		if (!attribute_name) {
			attribute_name = jump.jump_selector_attr;
		}
		
		// Move hash to attribute
		$link.setAttribute(href_attr, '#');
		$link.setAttribute(attribute_name, href_hash);
	});
}
